import Vue from 'vue'
import Router from 'vue-router'

import Index from '@/V3/Index.vue'
import DataDownload from '@/V3/Main/comDataDownload'
import Home from '@/V3/Main/comHome'
import Check from '@/V3/Main/comCheck'
import ExportData from '@/V3/Main/comExportData'

import OriginData from '@/V3/Main/comOriginData'

import Introduce from '@/V3/Main/comIntroduce'
import Login from '@/V3/Login'
import Forget from '@/V3/Forget'
import Register from '@/V3/Register'

import MyAccount from '@/V3/MyAccount'

Vue.use(Router)

export default new Router({
    mode: 'hash',
    routes: [
        {
            path: "/",
            name: 'Index',
            component: Index,
            redirect: '/home',
            children: [
                {
                    path: 'home',
                    name: 'home',
                    component: Home
                }, {
                    path: 'check',
                    name: 'check',
                    component: Check
                },
                {
                    path: 'exportData',
                    name: 'exportData',
                    component: ExportData
                },
                {
                    path: 'originData',
                    name: 'originData',
                    component: OriginData
                },
                {
                    path: 'dataDownload',
                    name: 'dataDownload',
                    component: DataDownload
                }, {
                    path: 'introduce',
                    name: 'introduce',
                    component: Introduce
                }, {
                    path: '/myAccount',
                    name: 'myAccount',
                    component: MyAccount
                }
            ]
        },
        {
            path: '/login',
            name: 'login',
            component: Login
        },
        {
            path: '/forget',
            name: 'forget',
            component: Forget
        },
        {
            path: '/register',
            name: 'register',
            component: Register
        },

    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js